import { useParams } from "react-router-dom";
import { useState } from "react";
import ChatInterface from "@/components/ai/chat-interface";
import ChatSessionsList from "@/components/ai/chat-sessions-list";

export default function LicitacionChatPage() {
  const { id } = useParams<{ id: string }>();
  const [selectedSessionId, setSelectedSessionId] = useState<string | undefined>();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleSessionSelect = (sessionId: string) => {
    setSelectedSessionId(sessionId);
  };

  const handleSessionCreated = (sessionId: string) => {
    setSelectedSessionId(sessionId);
    setRefreshKey((prev) => prev + 1);
  };

  const handleMessageSent = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const handleNewChat = () => {
    setSelectedSessionId(undefined);
  };

  return (
    <div className="h-[calc(100vh-20rem)] flex flex-col">
      <div className="flex-1 min-h-0 grid grid-cols-12 gap-4">
        {/* Historial de sesiones */}
        <div className="col-span-3 flex flex-col min-h-0">
          <div className="mb-3 flex-shrink-0">
            <h3 className="text-sm font-semibold text-gray-600">Historial</h3>
          </div>
          <div className="flex-1 min-h-0 overflow-hidden">
            <ChatSessionsList
              key={refreshKey}
              licitacionId={id}
              selectedSessionId={selectedSessionId}
              onSessionSelect={handleSessionSelect}
              onNewChat={handleNewChat}
            />
          </div>
        </div>

        {/* Chat */}
        <div className="col-span-9 min-h-0">
          <ChatInterface
            sessionId={selectedSessionId}
            licitacionId={id}
            onSessionCreated={handleSessionCreated}
            onMessageSent={handleMessageSent}
          />
        </div>
      </div>
    </div>
  );
}
